<template>
  <div class="nf-button" :style="{ width }">
    <div
      class="nf-button_box"
      :style="{
        'border-width': borderSize,
        'border-style': border,
        'border-radius': round,
      }"
    >
      <div>
        <Field
          :disabled="disabled"
          v-model="modelValue"
          :placeholder="placeholder"
          placeholder-class="input-placeholder"
          :type="passwordType"
          style="
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            background-color: transparent;
          "
          :style="{
            fontSize,
          }"
        >
          <template slot="right-icon">
            <span
              class="solts"
              @click="switchPasswordType"
              v-if="type == 'password' && modelValue != ''"
            >
              <van-icon name="eye" v-if="passwordType === 'password'" />
              <van-icon name="closed-eye" v-else />
            </span>
          </template>
        </Field>
        <div class="nf-button_box_password"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Icon as VanIcon } from "vant";
export default {
  components: {
    Field,
    VanIcon,
  },
  data() {
    return {
      passwordType: "text",
    };
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    border: {
      type: String,
      default: "solid",
    },
    borderInner: {
      type: String,
      default: "dashed",
    },
    placeholder: {
      type: String,
      default: "",
    },
    dash: {
      type: Boolean,
      default: true,
    },
    padding: {
      type: String,
      default: "0.1rem",
    },
    borderSize: {
      type: String,
      default: "0.01rem",
    },
    borderInnerSize: {
      type: String,
      default: "0.01rem",
    },
    borderInnerSize: {
      type: String,
      default: "0.01rem",
    },
    round: {
      type: String,
      default: "0.1rem",
    },
    width: {
      type: String,
      default: "100%",
    },
    fontColor: {
      type: String,
      default: "black",
    },
    fontSize: {
      type: String,
      default: "0.28rem",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
  },
  mounted() {
    this.passwordType = this.type || "text";
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.nf-button {
  padding: 0.02rem;

  &_box {
    border: 0.03rem solid #e5e5e5;
    border-width: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    padding: 0.08rem;
    text-align: center;

    &_solid {
    }
    &_dash {
      border-radius: 0.1rem;
      border: 0.01rem solid #e5e5e5;
    }
  }
  ::v-deep .van-cell {
    padding: 0 0.05rem;
    input[type="password"]::-ms-reveal {
      display: none;
    }
    .van-field__control {
      line-height: normal;

      &::-webkit-input-placeholder {
        color: rgb(118, 118, 118);
      }
    }
  }
}
</style>
